import request from '@teetsh/app/src/utils/request';

export function searchEtablissements({
  query,
  country,
  state,
}: {
  query: string;
  country: string;
  state?: string;
}) {
  return request('/etablissements', {
    method: 'POST',
    body: {
      query,
      country,
      state,
    },
  });
}
